import { c as _c } from "react/compiler-runtime";
import { Box, Center, Heading, Spinner, Text, VStack } from '@chakra-ui/react';
import { AppLayout } from '@src/components/sco/AppLayout';
import { PitchDeckAuditorShell } from '@src/components/sco/PitchDeckAuditor/PitchDeckAuditorShell';
import { usePitchDeckView } from '@src/components/sco/PitchDeckAuditor/hooks/useScoPitchDeck';
import { PitchDeckMainPanel } from '@src/components/sco/PitchDeckAuditor/main/PitchDeckMainPanel';
import { PitchDeckProcessing } from '@src/components/sco/PitchDeckAuditor/processing/PitchDeckProcessing';
import { PitchDeckNeedsUpload } from '@src/components/sco/PitchDeckAuditor/start/PitchDeckNeedsUpload';
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar';
import { useRouter } from 'next/router';
function ShellMessage(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ScoSiteNavBar />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <AppLayout header={t1} panels={[{
      id: "pitch-deck-single",
      children: <Center padding={10} width="full">{children}</Center>
    }]} />;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}

/**
 * The full Pitch Deck Auditor experience for a single deck, shared by the
 * deck-overview route and the per-slide route (which only differ by activeSlideId).
 */
export function PitchDeckWorkspace(t0) {
  const $ = _c(22);
  const {
    pitchDeckId,
    activeSlideId: t1
  } = t0;
  const activeSlideId = t1 === undefined ? null : t1;
  const router = useRouter();
  const {
    deck,
    raw,
    loading,
    error,
    refetch
  } = usePitchDeckView(pitchDeckId);
  let t2;
  if ($[0] !== pitchDeckId || $[1] !== router) {
    t2 = slideId => {
      if (slideId) {
        router.push(`/pitch-decks/${pitchDeckId}/slides/${slideId}`);
      } else {
        router.push(`/pitch-decks/${pitchDeckId}`);
      }
    };
    $[0] = pitchDeckId;
    $[1] = router;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onSelectSlide = t2;
  let t3;
  if ($[3] !== refetch) {
    t3 = () => {
      refetch();
    };
    $[3] = refetch;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const onReplaced = t3;
  if (loading && !deck) {
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <ShellMessage><Spinner colorPalette="orange" size="xl" /></ShellMessage>;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return t4;
  }
  if (error || !deck) {
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <ShellMessage><VStack gap={2}><Heading size="md">Deck not found</Heading><Text color="fg.muted" fontSize="sm">This pitch deck doesn’t exist or you don’t have access to it.</Text></VStack></ShellMessage>;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  if (!deck.hasStoredFile) {
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <ScoSiteNavBar />;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    const t5 = raw?.title;
    let t6;
    if ($[8] !== deck.pitchDeckId || $[9] !== onReplaced || $[10] !== t5) {
      t6 = <AppLayout header={t4} panels={[{
        id: "pitch-deck-single",
        children: <Box paddingX={4} width="full"><PitchDeckNeedsUpload pitchDeckId={deck.pitchDeckId} title={t5} onUploaded={onReplaced} /></Box>
      }]} />;
      $[8] = deck.pitchDeckId;
      $[9] = onReplaced;
      $[10] = t5;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    return t6;
  }
  let t4;
  if ($[12] !== activeSlideId || $[13] !== deck || $[14] !== onSelectSlide) {
    t4 = deck.isAudited ? <PitchDeckMainPanel activeSlideId={activeSlideId} deck={deck} onSelectSlide={onSelectSlide} /> : <Box width="full"><PitchDeckProcessing deck={deck} /></Box>;
    $[12] = activeSlideId;
    $[13] = deck;
    $[14] = onSelectSlide;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const mainPanel = t4;
  let t5;
  if ($[16] !== activeSlideId || $[17] !== deck || $[18] !== mainPanel || $[19] !== onReplaced || $[20] !== onSelectSlide) {
    t5 = <PitchDeckAuditorShell activeSlideId={activeSlideId} deck={deck} mainPanel={mainPanel} onReplaced={onReplaced} onSelectSlide={onSelectSlide} />;
    $[16] = activeSlideId;
    $[17] = deck;
    $[18] = mainPanel;
    $[19] = onReplaced;
    $[20] = onSelectSlide;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  return t5;
}